import { GetUsersResponse } from '@inplay/models';
import { CountryProps } from '../dropDownInput/dropDownInput.type';
import { Dispatch, SetStateAction } from 'react';

export type UserModalProps<Kebabaction extends string = string> = {
  isOpenUserModal: boolean;
  handleCloseUserModal: () => void;
  handleEditUser?: () => void;
  operation: UserOperation;
  selectedUser: GetUsersResponse | undefined;
  onCancel: () => void;
  viewUserRowIndex: number;
  onKebabSelect: (
    action: Kebabaction,
    row: GetUsersResponse,
    rowIndex: number,
  ) => void;
  loadingMenu: { rowIndex: number; action: Kebabaction } | null;
  activeLabel: boolean;
  setActiveLabel: Dispatch<SetStateAction<boolean>>;
  onChangeSwitch: (checked: boolean) => void;
  activeDeactiveLoading?: boolean;
};

export enum UserOperation {
  ADD = 'add',
  VIEW = 'view',
  EDIT = 'edit',
}

export enum PinOptionType {
  DEFAULT = 'default',
  CUSTOM = 'custom',
}

export type UserFormValues = {
  userType: string;
  firstName: string;
  lastName: string;
  venue: string;
  email: string;
  mobile: string;
  venueBranch: string[];
  country: CountryProps;
};
